define('CreditApplication.Model', [
    'Backbone',
    'Utils'
], function (
    Backbone,
    Utils
) {
    'use strict';

    return Backbone.Model.extend({
        urlRoot: Utils.getAbsoluteUrl(
            getExtensionAssetsPath(
                'services/CreditApplication.Service.ss'
            )
        ),

        validation: {
            companyName: { required: true, msg: 'Company Name is required.' },
            phoneNumber: { required: true, msg: 'Phone Number is required.' },
            email: { required: true, pattern: 'email', msg: 'A valid Email is required.' },
            shipAddr1: { required: true, msg: 'Shipping Street Address is required.' },
            shipCity: { required: true, msg: 'Shipping City is required.' },
            shipState: { required: true, msg: 'Shipping State / Province is required.' },
            shipPostal: { required: true, msg: 'Shipping Postal / Zip Code is required.' },
            shipCountry: { required: true, msg: 'Shipping Country is required.' },
            companyType: { required: true, msg: 'Company Type is required.' },

            apFirstName: { required: true, msg: 'Accounts Payable First Name is required.' },
            apLastName: { required: true, msg: 'Accounts Payable Last Name is required.' },
            apPhone: { required: true, msg: 'Accounts Payable Phone Number is required.' },
            apEmail: { required: true, pattern: 'email', msg: 'Accounts Payable Email is required.' },
            billAddr1: { required: true, msg: 'Billing Street Address is required.' },
            billCity: { required: true, msg: 'Billing City is required.' },
            billState: { required: true, msg: 'Billing State / Province is required.' },
            billPostal: { required: true, msg: 'Billing Postal / Zip Code is required.' },
            billCountry: { required: true, msg: 'Billing Country is required.' },

            bankName: { required: true, msg: 'Bank Name is required.' },
            bankBranchName: { required: true, msg: 'Branch Name is required.' },
            bankPhone: { required: true, msg: 'Bank Branch Phone Number is required.' },
            bankAddr1: { required: true, msg: 'Bank Street Address is required.' },
            bankCity: { required: true, msg: 'Bank City is required.' },
            bankState: { required: true, msg: 'Bank State / Province is required.' },
            bankPostal: { required: true, msg: 'Bank Postal / Zip Code is required.' },
            bankCountry: { required: true, msg: 'Bank Country is required.' },

            fedTaxId: { required: true, msg: 'Federal Tax ID # is required.' },
            creditRequested: { required: true, msg: 'Amount of Credit requested is required.' },
            poRequired: { required: true, msg: 'Please select if Purchase Orders are required.' },
            checkingAcctNum: { required: true, msg: 'Checking Acct. # is required.' },
            checkingRoutingNum: { required: true, msg: 'Checking Routing # is required.' },
            savingsAcctNum: { required: true, msg: 'Savings Acct. # is required.' },
            savingsRoutingNum: { required: true, msg: 'Savings Routing # is required.' },
            authReleaseInfo: { required: true, msg: 'Authorization to release confidential information is required.' },
            authSignature: { required: true, msg: 'Authorization Signature is required.' },

            ref1CompanyName: { required: true, msg: 'Reference 1 Company Name is required.' },
            ref1ContactName: { required: true, msg: 'Reference 1 Contact Name is required.' },
            ref1Phone: { required: true, msg: 'Reference 1 Phone Number is required.' },
            ref1Addr1: { required: true, msg: 'Reference 1 Street Address is required.' },
            ref1City: { required: true, msg: 'Reference 1 City is required.' },
            ref1State: { required: true, msg: 'Reference 1 State / Province is required.' },
            ref2CompanyName: { required: true, msg: 'Reference 2 Company Name is required.' },
            ref2ContactName: { required: true, msg: 'Reference 2 Contact Name is required.' },
            ref2Phone: { required: true, msg: 'Reference 2 Phone Number is required.' },
            ref2Addr1: { required: true, msg: 'Reference 2 Street Address is required.' },
            ref2City: { required: true, msg: 'Reference 2 City is required.' },
            ref2State: { required: true, msg: 'Reference 2 State / Province is required.' },

            agreeTerms1: { required: true, msg: 'Agreement to 30-day invoice payment terms is required.' },
            agreeTerms2: { required: true, msg: 'Agreement to 7-day claim policy is required.' },
            agreeTerms3: { required: true, msg: 'Acceptance of terms and authorization is required.' },
            termsSignature: { required: true, msg: 'Terms Signature is required.' },
            applicationDate: { required: true, msg: "Today's Date is required." }
        }
    });
});
